module.exports = __webpack_public_path__ + "Tinebase/js/ace-ext-static_highlight-FAT.js";